import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";

@Injectable()
export class SurveyParserService {
  generatedJSON: any = { pages: [] };

  responseJSON: any = {
    surveyId: null,
    status: null,
    responses: []
  };

  constructor() {}

  clear() {
    this.generatedJSON = { pages: [] };
    this.responseJSON = {
      surveyId: null,
      status: null,
      responses: []
    };
  }

  viewParser(researchData, surveyData) {
    if (researchData.isParticipated) {
    } else {
      return this.buildSurveyJsJson(surveyData);
    }
  }

  buildSurveyJsJson(surveyData): Observable<any[]> {
    surveyData.forEach(surveyObject => {
      let questionData = surveyObject.questions;

      if (surveyObject.questions.questionType.type == "radiogroup") {
        this.getRadioGroupData(questionData);
      } else if (surveyObject.questions.questionType.type == "checkbox") {
        this.getCheckBoxData(questionData);
      } else if (surveyObject.questions.questionType.type == "text") {
        this.getTextBoxData(questionData);
      } else if (surveyObject.questions.questionType.type == "nouislider") {
        this.getSliderData(questionData);
      } else if (surveyObject.questions.questionType.type == "dropdown") {
        this.getDropdownData(questionData);
      }
    });
    this.generatedJSON.completedHtml = "<p></p>";

    return Observable.of(this.generatedJSON);
  }

  getRadioGroupData(questionData) {
    this.generatedJSON.pages.push({
      questions: [
        {
          type: "radiogroup",
          name: questionData.id,
          title: questionData.questionText,
          isRequired: true,
          colCount: 1,
          choices: this.getRadioChoicesGroupData(questionData),
          renderAs: "prettycheckbox",
          requiredErrorText: "Please choose your option"
        }
      ]
    });

  }

  getRadioChoicesGroupData(questionData) {
    let choicesResArray: Array<object> = [];
    questionData.choices.forEach(element => {
      choicesResArray.push({
        value: element.id,
        text: element.text
      });
    });
    return choicesResArray;
  }

  getCheckBoxData(questionData) {
    this.generatedJSON.pages.push({
      questions: [
        {
          type: "checkbox",
          name: questionData.id,
          title: questionData.questionText,
          isRequired: true,
          colCount: 2,
          renderAs: "prettycheckbox",
          requiredErrorText: "Please choose your option(s)",
          choices: this.getCheckBoxChoicesGroupData(questionData)
        }
      ]
    });

  }

  getCheckBoxChoicesGroupData(questionData) {
    let choicesResArray: Array<object> = [];
    questionData.choices.forEach(element => {
      choicesResArray.push({
        value: element.id,
        text: element.text
      });
    });
    return choicesResArray;
  }

  getTextBoxData(questionData) {
    this.generatedJSON.pages.push({
      questions: [
        {
          type: "text",
          name: questionData.id,
          questionType: "text",
          title: questionData.questionText,
          isRequired: true,
          requiredErrorText: "Please fill in the field"
        }
      ]
    });
    //
  }

  getSliderData(questionData) {
    this.generatedJSON.pages.push({
      questions: [
        {
          type: "nouislider",
          name: questionData.id,
          title: questionData.questionText,
          rangeMax: questionData.validationRules[0].rangeMax,
          rangeMin: questionData.validationRules[0].rangeMin,
          step: questionData.validationRules[0].step,
          isRequired: true,
          requiredErrorText: "Please choose your range"
        }
      ]
    });
  }

  getDropdownData(questionData) {
    this.generatedJSON.pages.push({
      questions: [
        {
          type: "dropdown",
          name: questionData.id,
          title: questionData.questionText,
          isRequired: true,
          colCount: 0,
          choices: this.getDropdownChoicesGroupData(questionData),
          requiredErrorText: "Please select any option from the list"
        }
      ]
    });
  }

  getDropdownChoicesGroupData(questionData) {
    let choicesResArray: Array<object> = [];
    questionData.choices.forEach(element => {
      choicesResArray.push({
        value: element.id,
        text: element.text
      });
    });
    return choicesResArray;
  }

  sendResponseParser(researchData, surveyData, surveyJsResData) {
    // if (researchData.isParticipated) {
    // } else {
    this.responseJSON.status = "submitted";
    this.responseJSON.surveyId = researchData.surveyId;
    // }



    Object.keys(surveyJsResData).forEach(questionId => {
      // geting question id from survey js response JSON data
      surveyData.forEach(response => {
        if (questionId == response.questions.id) {
          // checking for similar question id
          if (response.questions.questionType.type == "radiogroup") {
            // finding question type of matching question id
            this.getRadioGroupResData(
              researchData,
              questionId,
              surveyJsResData
            );
          } else if (response.questions.questionType.type == "checkbox") {
            this.getCheckBoxResData(researchData, questionId, surveyJsResData);
          } else if (response.questions.questionType.type == "text") {
            this.getTextBoxResData(researchData, questionId, surveyJsResData);

          } else if (response.questions.questionType.type == "dropdown") {

            this.getDropdownResData(researchData, questionId, surveyJsResData);
          } else if (response.questions.questionType.type == "nouislider") {
            this.getSliderResData(researchData, questionId, surveyJsResData);
          }
          // else if (response.questions.questionType.type == "nouislider") {
          //   this.getSliderResData(researchData, questionId, surveyJsResData);
          // }
        }
      });
    });

    return Observable.of(this.responseJSON);
  }

  getRadioGroupResData(researchData, questionId, responseData) {
    this.responseJSON.responses.push({
      id: null,
      questionId: questionId,
      choiceId: responseData[questionId],
      responseText: null,
      isActive: true
    });
  }

  getCheckBoxResData(researchData, questionId, responseData) {
    Object.keys(responseData[questionId]).forEach(loop => {
      this.responseJSON.responses.push({
        id: null,
        questionId: questionId,
        choiceId: responseData[questionId][loop],
        responseText: null,
        isActive: true
      });
    });
  }

  getTextBoxResData(researchData, questionId, responseData) {
    this.responseJSON.responses.push({
      id: null,
      questionId: questionId,
      choiceId: null,
      responseText: responseData[questionId],
      isActive: true
    });
  }

  getSliderResData(researchData, questionId, responseData) {
    this.responseJSON.responses.push({
      id: null,
      questionId: questionId,
      choiceId: null,
      responseText: responseData[questionId],
      isActive: true
    });
  }

  getDropdownResData(researchData, questionId, responseData) {
    this.responseJSON.responses.push({
      id: null,
      questionId: questionId,
      choiceId: responseData[questionId],
      responseText: null,
      isActive: true
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/survey-view-parser.service.ts